import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirection des anciennes URLs de réservation (liens externes/legacy) vers la liste des studios disponibles.
export const Route = createFileRoute("/reservation/studio/$number")({
  beforeLoad: () => {
    throw redirect({ to: "/studios/disponibles", search: { type: undefined } });
  },
});
